import { phoneFormatHandler } from "../../lib/common/validation";
import { TApiTechnician } from "../../lib/types/dentalTechs";
import { TProcessStates } from "../../lib/types/general";

type TDentalTechInfoContactEditableProps = {
    userInfo: TApiTechnician;
    isSomePartBeingEdited: boolean;
    editableOnClickHandler: (e: any) => void;
};
export const DentalTechInfoContactEditable = ({ userInfo, isSomePartBeingEdited, editableOnClickHandler }: TDentalTechInfoContactEditableProps) => {
    const isPhoneVerified = userInfo.verifications.phone === true;
    const isEmailVerified = userInfo.verifications.email === true;

    return (
        <div className="row w-100 gx-2 align-items-start m-0">
            <div className="col px-0 text-break">
                <div>
                    <p className="m-0">
                        <i className="fa-solid fa-envelope fa-xs text-info me-3"></i>
                        {userInfo?.other?.email} {isEmailVerified && <i title="Email Verified" className="fas fa-check-circle text-success"></i>}
                        {!!!userInfo.other.email && (
                            <small className="alert alert-danger py-0 px-2" role="alert">
                                No email found.
                            </small>
                        )}
                    </p>
                </div>
                <div className="">
                    <span id="verify_phone-progress"></span>
                    <p className="mb-0 mt-2">
                        <i className="fa-solid fa-phone fa-xs text-info me-3"></i>
                        {!!userInfo.other.phone ? (
                            <>
                                {phoneFormatHandler(userInfo.other.phone)}{" "}
                                {isPhoneVerified && <i title="Phone Verified" className="fas fa-check-circle text-success"></i>}
                            </>
                        ) : (
                            ""
                        )}
                        {!!!userInfo.other.phone && (
                            <small className="alert alert-danger py-0 px-2" role="alert">
                                No phone number found.
                            </small>
                        )}
                    </p>
                </div>
                {!!userInfo.other?.linkedin && (
                    <div className="text-break mt-2">
                        <a
                            href={`https://www.linkedin.com/in/${userInfo.other.linkedin}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="linkedin-button"
                        >
                            <i className="fab fa-linkedin fa-xs text-info me-3 mb-0"></i>
                            {userInfo.other.linkedin}
                            <i className="fa-solid fa-arrow-up-right-from-square fa-2xs ms-2"></i>
                        </a>
                    </div>
                )}
                {!!!userInfo.other.linkedin && (
                    <p className="mb-0 mt-2">
                        <i className="fab fa-linkedin fa-xs text-info me-3 mb-0"></i>
                        <small className="alert alert-danger py-0 px-2" role="alert">
                            No linkedIn link found.
                        </small>
                    </p>
                )}
            </div>
            {!isSomePartBeingEdited && (
                <div
                    className="col-auto px-0 fileTooltip rightEdit ms-auto"
                    role="button"
                    data-tooltip=" Edit "
                    onClick={editableOnClickHandler}
                    data-testid="edit-icon"
                >
                    <i className="fa-solid fa-pen-to-square fa-xs p-2 shadow editIcon" data-testid="edit-icon"></i>
                </div>
            )}
        </div>
    );
};

type TDentalTechInfoContactReadOnlyProps = {
    userInfo: TApiTechnician;
    currWorkingState: TProcessStates;
};

export const DentalTechInfoContactReadonly = ({ userInfo, currWorkingState }: TDentalTechInfoContactReadOnlyProps) => {
    const isPhoneVerified = userInfo.verifications.phone === true;
    const isEmailVerified = userInfo.verifications.email === true;

    return (
        <div>
            <div className={"text-break " + (currWorkingState !== "done" ? "cssLoading" : "")}>
                {!!userInfo.other?.email && (
                    <p className="m-0">
                        <i className="fa-solid fa-envelope fa-xs me-3 text-info"></i>
                        {userInfo?.other?.email} {isEmailVerified && <i title="Email Verified" className="fas fa-check-circle text-success"></i>}
                    </p>
                )}
                {!!!userInfo.other.email && (
                    <p style={{ color: "#a5a5a5" }} className="m-0">
                        <i className="fa-solid fa-envelope fa-xs me-3"></i>
                        <small> No email to show</small>
                    </p>
                )}
                {!!userInfo.other?.phone && (
                    <p className="m-0">
                        <i className="fa-solid fa-phone fa-xs me-3 text-info"></i>
                        {phoneFormatHandler(userInfo?.other?.phone)}{" "}
                        {isPhoneVerified && <i title="Phone Verified" className="fas fa-check-circle text-success"></i>}
                    </p>
                )}
                {!!!userInfo.other.phone && (
                    <p style={{ color: "#a5a5a5" }} className="m-0">
                        <i className="fa-solid fa-phone fa-xs me-3"></i>
                        <small> No phone number to show</small>
                    </p>
                )}
                {!!!userInfo.other.linkedin && (
                    <p style={{ color: "#a5a5a5" }} className="m-0">
                        <i className="fab fa-linkedin fa-xs me-3"></i>
                        <small> No LinkedIn to show</small>
                    </p>
                )}
                {!!userInfo.other.linkedin && (
                    <a href={`https://www.linkedin.com/in/${userInfo.other.linkedin}`} target="_blank" rel="noopener noreferrer" data-testid="linkedin-button">
                        <i className="fab fa-linkedin fa-xs me-3 text-info"></i>
                        {userInfo.other.linkedin}
                        <i className="fa-solid fa-arrow-up-right-from-square fa-2xs ms-2"></i>
                    </a>
                )}
            </div>
        </div>
    );
};
